jQuery(document).ready(function () {
  if (!jQuery("#support-content-restructure").length) return
  bindSupportPage()
})

function bindSupportPage() {
  bindAccountFilterChanges()
  fetchAccountsList()
}
function bindSubmitTicketFormValidation() {
  new FormValidation({
    formSelector: jQuery('#client-support-form'),
    scrollContainer: '.modal',
  }).init()
}

function bindAccountFilterChanges() {
  jQuery('.account-filter__wrapper select').on('change', function() {
    fetchAccountsList()
  })
}

function fetchAccountsList() {
  jQuery.ajax({
    url: jQuery('.accounts-list').data('source'),
    type: 'GET',
    data: filterMembershipSelection(),
  })
}

function filterMembershipSelection() {
  const membership_id = jQuery('#membership_id').val()
  return { membership_id }
}

function bindAccountList() {
  const copyIcon = "fa-copy"
  const checkIcon = "fa-check"
  jQuery('.email-field').on('click', function() {
    const copyText = jQuery(this).find('.copy-text').html()
    navigator.clipboard.writeText(copyText)
    const $icon = jQuery(this).find('.icon')
    $icon.removeClass(copyIcon).addClass(checkIcon)
    setTimeout(function() { $icon.removeClass(checkIcon).addClass(copyIcon) }, 2000)
  })
}


window.bindSupportPage = bindSupportPage
window.bindAccountList = bindAccountList
window.bindSubmitTicketFormValidation = bindSubmitTicketFormValidation
